////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const headerCarousel = {
	storeActiveValue: (activeValue) => ({
		type: ActionsTypes.HEADER_CAROUSEL_STORE_ACTIVE_VALUE,
		payload: {
			activeValue,
		},
	}),
}

export default headerCarousel
